import React from 'react'

import { Stack, StackProps } from '../Stack'
import { Icon } from '../Icon'
import { IconProps } from '@chakra-ui/core'

export interface StarRatingProps extends Omit<StackProps, 'size'> {
  /** A number from 0 to 5. If a decimal is given, this will round to the nearest whole number. */
  value?: number
  size?: IconProps['fontSize']
}

export const StarRating = ({ value = 0, size = 'md', ...restProps }: StarRatingProps) => {
  const _value = Math.round(value)

  return (
    <Stack spacing="1px" direction="row" {...restProps}>
      {new Array(5).fill(1).map((_, i) => (
        <Icon name="star" color={i < _value ? 'yellow.400' : 'gray.300'} fontSize={size} />
      ))}
    </Stack>
  )
}

export default StarRating
